import React, { useState, useRef } from "react";
import { connect } from "react-redux";
import ProductCode from "./ProductCode";
import ProductName from "./ProductName";
import Variations from "./Variations";
import BarcodelistView from "./BarcodelistView";
import Datewisebarcode from "./Datewisebarcode";
import "../../../barcode.css";

import {
  Layout,
  Breadcrumb,
  Row,
  Col,
  Select,
  Divider,
  AutoComplete,
  Form,
  Tabs
} from "antd";
const { Option } = Select;

const Barcode = () => {
  const [reload, setreload] = useState(true);
  const [loading, setloading] = useState(false);
  const count = useRef(0);
  const [products, setproducts] = useState([]);
  const [variations, setvariations] = useState([]);
  const SelectedProduct = useRef([]);
  const SelectedVariation = useRef([]);
  const barcodelist = useRef([]);
  const [form] = Form.useForm();

  const onChange = (key) => {
    barcodelist.current = []
    setreload(!reload);
  };

  const addProduct = () => {
    return (
      <>
        <Tabs onChange={onChange}>
          <Tabs.TabPane tab="Filter by individual product" key="1">
            <Row>
              <Col span={6}>
                <ProductCode
                  setproducts={setproducts}
                  setvariations={setvariations}
                  setloading={setloading}
                />
              </Col>
              <Col span={6}>
                <ProductName
                  products={products}
                  setvariations={setvariations}
                  loading={loading}
                />
              </Col>
              <Variations
                variations={variations}
                barcodelist={barcodelist}
                setreload={setreload}
                reload={reload}
                loading={loading}
              />
            </Row>
          </Tabs.TabPane>
          <Tabs.TabPane tab="Filter by product create date" key="2">
            <Datewisebarcode setloading={setloading} barcodelist={barcodelist} setreload={setreload}
              reload={reload} />

          </Tabs.TabPane>
        </Tabs>
        <Divider />

        <BarcodelistView
          barcodelist={barcodelist}
          reload={reload}
          count={count}
        />
      </>
    );
  };

  return (
    <>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Products</Breadcrumb.Item>
        <Breadcrumb.Item>barcode</Breadcrumb.Item>
      </Breadcrumb>
      <div className="site-layout-background main-frame">{addProduct()}</div>
    </>
  );
};

export default connect(null, {})(Barcode);
